<div class="add-button-container">
  <button mat-raised-button (click)="createBook()">Dodaj książkę</button>
</div>

<app-books-list-container></app-books-list-container>

<app-books-genres-summary></app-books-genres-summary>
